export type ISlideSteps = (
  wrapper: IjQueryElmOrHtmlElm | string,
  direction?: 'next' | 'prev'
) => void;

export function slideSteps(wrapper: IjQueryElmOrHtmlElm | string, direction = 'next') {
  const $wrapper = (typeof wrapper === 'object' ? $(wrapper) : $(`#${wrapper}`)) as IjQueryElm;
  const $slideStepHolder = $wrapper.find('.slide-step-holder');
  const $steps = $slideStepHolder.find('.slide-step');
  const totalSteps = $steps.length;

  // Current step
  const currentActiveStep = $steps.filter(
    (_, slide) => !$(slide).hasClass('off-left') && !$(slide).hasClass('off-right')
  );
  const currentStepNumber: number = $(currentActiveStep).data('step');
  const currentStepHeight: number = $(currentActiveStep).outerHeight() || 0;

  // Previous step
  const prevStepNumber = currentStepNumber - 1;
  const prevStep = $steps.filter((_, slide) => $(slide).data('step') === prevStepNumber);
  const prevStepHeight = $(prevStep).outerHeight() || 0;

  // Next step
  const nextStepNumber = currentStepNumber + 1;
  const nextStep = $steps.filter((_, slide) => $(slide).data('step') === nextStepNumber);
  const nextStepHeight = $(nextStep).outerHeight() || 0;

  // Get minimum height for transition
  let minHeight = currentStepHeight;
  if (direction === 'next') {
    if (nextStepHeight > currentStepHeight) {
      minHeight = nextStepHeight;
    }
  } else if (prevStepHeight > currentStepHeight) {
    minHeight = prevStepHeight;
  }

  // Return if requested step does not exist
  if (direction === 'next' && nextStepNumber > totalSteps) {
    return;
  }
  if (direction !== 'next' && prevStepNumber < 1) {
    return;
  }

  // Make sure holder has enough height during animation
  $slideStepHolder.css('min-height', minHeight);

  if (direction === 'next') {
    $(currentActiveStep)
      .finish()
      .addClass('absolute')
      .animate({ left: '-100%' }, 250, () => {
        $(currentActiveStep)
          .addClass('off-left')
          .removeAttr('style');
      });
    $(nextStep)
      .finish()
      .addClass('absolute')
      .animate({ left: '0%' }, 250, () => {
        $(nextStep)
          .removeClass('off-right absolute')
          .removeAttr('style');
      });
  } else {
    $(currentActiveStep)
      .finish()
      .addClass('absolute')
      .animate({ right: '-100%' }, 250, () => {
        $(currentActiveStep)
          .addClass('off-right')
          .removeAttr('style');
      });
    $(prevStep)
      .finish()
      .addClass('absolute')
      .animate({ left: '0%' }, 250, () => {
        $(prevStep)
          .removeClass('off-left absolute')
          .removeAttr('style');
      });
  }
}
